import PropTypes from "prop-types";
import React, { PureComponent } from "react";
import Choice from "./Choice";

export default class Choices extends PureComponent {
  static propTypes = {
    headline: PropTypes.string,
    overline: PropTypes.string,
    label: PropTypes.string,
    handleClick: PropTypes.func,
    checked: PropTypes.bool,
    children: PropTypes.node,
    sections: PropTypes.bool,
    id: PropTypes.any
  };

  static defaultProps = {
    overline: "Välj ett alternativ:",
    handleClick: () => {},
    checked: false
  };
  static Choice = Choice;

  render() {
    const {
      id,
      children,
      sections,
      checked,
      overline,
      headline,
      label,
      handleClick
    } = this.props;

    const content = sections ? <Choice /> : children;

    return (
      <div className="Choices">
        <div className="Choices__heading">
          <div className="Choices__headline">{headline}</div>
          <div className="Choices__overline">{overline}</div>
        </div>
        <div className="Choices__content">{content}</div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Choices/Choices.js